
// import { API } from './categories';
// export const fetchProducts    = params => API.get('/products', { params });
// export const fetchProductById = id     => API.get(`/products/${id}`);

import axios from 'axios';

const API = axios.create({ baseURL: 'https://biosurgebackend-1.onrender.com/api' });

export const addProduct = data => API.post('/products', data);
export const fetchProducts = (params={}) => API.get('/products',{params});
export const fetchProductById = id => API.get(`/products/${id}`);
export const deleteProduct = id => API.delete(`/products/${id}`);
export const updateProduct = (id, data) => API.put(`/products/${id}`, data);
